const Input = ({ register, type, name, placeholder, errors, onChange, value }) => {
  const reg = register || {};

  const handleChange = onChange
    ? (e) => {
        reg.onChange?.(e);
        onChange(e);
      }
    : reg.onChange;

  return (
    <div className="Input">
      <input
        type={type}
        ref={reg.ref}
        name={reg.name || name}
        placeholder={placeholder}
        onBlur={reg.onBlur}
        onChange={handleChange}
        {...(value !== undefined ? { value: value ?? '' } : {})}
      />
      {errors[name] && errors[name].type === "required" && <span className="danger">Obrigatório *</span>}
    </div>
  );
};

export default Input;